import { render, staticRenderFns } from "./BaseYxVoucher.vue?vue&type=template&id=420ca637&scoped=true"
import script from "./BaseYxVoucher.vue?vue&type=script&lang=js"
export * from "./BaseYxVoucher.vue?vue&type=script&lang=js"
import style0 from "./BaseYxVoucher.vue?vue&type=style&index=0&id=420ca637&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "420ca637",
  null
  
)

export default component.exports